import { AccordionBodyItemView } from "component/Accordion";

export const ReportTypeInfoView = (props) => {
  const { formData } = props;
  const isExistingReport = formData?.info?.general?.from_existing_ha_report;

  return (
    <AccordionBodyItemView
      accordionSubId={(
        <div>
        </div>
      )}
      titleUA="Тип звіту"
      titleEN="Report type"
      children={(
        <div className="flex-group no-wrap">
          {isExistingReport ? (
            <>
              <div>Оновлення існуючого / Update existing</div>
            </>
          ) : (
            <>
              <div>Новий / New</div>
            </>
          )}
        </div>
      )}
    />
  );
};